import React, { Component } from "react";
import { withRouter } from "react-router";

class Dialog extends Component {
  constructor(props) {
    super();

    this.state = {
      visible: false,
    };

    this.styles = { backgroundHeader: {}, widthModal: {}, heightModal: {} };
  }

  componentDidMount() {
    this.setState({
      visible: this.props.show || false,
    });
  }

  componentDidUpdate(previousProps) {
    if (previousProps.show !== this.props.show) {
      this.setState({
        visible: this.props.show || false,
      });
    }
  }

  closeModal() {
    this.setState({
      visible: false,
    });
  }

  setStyles(styles) {
    this.styles = { backgroundHeader: {}, widthModal: {}, heightModal: {} };
    switch (this.props.type) {
      case "Error":
        this.styles.backgroundHeader = {
          background: "linear-gradient(90deg, #f16464 0%, #e23c3c 100%)",
        };
        this.styles.widthModal = { width: "20rem" };
        break;
      case "Info":
        this.styles.widthModal = { width: "20rem" };
        break;
      case "Video":
        this.styles.widthModal = { width: "45rem" };
        break;
      default:
        this.styles.widthModal = {};
        break;
    }
  }

  render() {
    return (
      <>
        {this.setStyles()}
        <div
          className="modal fade show modal-backdrop"
          style={this.state.visible ? {} : { display: "none" }}
        >
          <div className="modal-content" style={this.styles.widthModal}>
            <div className="modal-header" style={this.styles.backgroundHeader}>
              <h5 className="modal-title">{this.props.title}</h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                aria-label="Close"
                onClick={() => {
                  if (this.props.closeInternal) {
                    this.props.closeInternal();
                  } else {
                    this.closeModal();
                  }
                }}
              ></button>
            </div>
            {this.props.message ?
              <div className="modal-body">
                <p>{this.props.message}</p>
              </div>: null
            }

            {this.props.child ?
              this.props.child
            :
              null}
            
            {this.props.type !== "Video" ? (
              <div className="modal-footer">
                {this.props.deny ? (
                  <button
                    type="button"
                    className="btn bt-default"
                    data-bs-dismiss="modal"
                    onClick={() => {
                      this.props.deny();
                    }}
                  >
                    Cancelar
                  </button>
                ) : null}

                <button
                  type="button"
                  className="btn bt"
                  style={{
                    padding: "10px 12px",
                  }}
                  onClick={() => {
                    typeof this.props.confirmation === 'function'
                      ? this.props.confirmation()
                      : this.closeModal();
                  }}
                >
                  OK
                </button>
              </div>
            ) : null}
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(Dialog);
